module.exports = __webpack_public_path__ + "static/media/FB_IMG_1558775250680.b0f5da4a.jpg";